'use strict';

module.exports = {
    nav: '',
    count: '',
    wrapper: 'pagination',
    list: 'pagination-list',
    item: '',
    link: 'pagination-link',
    next: '',
    prev: '',
    active: 'is-current',
    disabled: '' // uses the disabled HTML attirbute
};


//////////////////
// WEBPACK FOOTER
// ./~/vue-pagination-2/compiled/themes/bulma.js
// module id = 817
// module chunks = 1